"use client";

import VERTICAL_OPTIONS from "@/constants/VerticalOptions";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import OptionsLinkSection from "./OptionsLinkSection";
import BREED_OPTIONS from "@/constants/BreedOptions";
import DISCIPLINE_OPTIONS, {
  OTT_DISCIPLINE,
} from "@/constants/DisciplineOptions";
import { BoxWithGutters } from "../common/BoxWithGutters";
import { NAV_SELECTED_BACKGROUND_COLOR } from "@/app/layout/LayoutConstants";
import { MENU_ITEM_ICONS } from "@/app/layout/GlobalMenu";

const CATEGORY_OPTIONS: {
  id: string;
  label: string;
  slug: string;
  icon: React.ReactNode;
}[] = [
  ...VERTICAL_OPTIONS.filter((x) => x.slug !== "everything-equine"),
  OTT_DISCIPLINE,
].map((o) => ({
  id: o.id,
  label: o.label,
  slug: o.slug,
  icon: MENU_ITEM_ICONS[o.slug],
}));

export default function HomepageLinksSection() {
  return (
    <BoxWithGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        paddingTop: 4,
        paddingBottom: 4,
        justifySelf: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h5" component="h2">
          Browse by Category
        </Typography>
        <Box
          sx={(theme) => ({
            display: "grid",
            alignSelf: "stretch",
            gap: 4,
            a: {
              display: "flex",
              alignItems: "stretch",
              justifyContent: "center",
            },
            gridTemplateColumns: "repeat(4, 1fr)",
            [theme.breakpoints.down("xl")]: {
              gridTemplateColumns: "repeat(3, 1fr)",
            },
            [theme.breakpoints.down("lg")]: {
              gridTemplateColumns: "repeat(2, 1fr)",
            },
            [theme.breakpoints.down("sm")]: {
              gap: 2,
            },
          })}
        >
          {CATEGORY_OPTIONS.filter((x) => x).map((vertical) => (
            <Link key={vertical.id} href={`/for-sale/${vertical.slug}`}>
              <Typography
                sx={(theme) => ({
                  backgroundColor: NAV_SELECTED_BACKGROUND_COLOR,
                  padding: theme.spacing(4, 2),
                  fontSize: theme.typography.h5.fontSize,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  width: "100%",
                  borderRadius: 10,
                  justifyContent: "center",
                  gap: 1,
                  "img, .MuiSvgIcon-root": {
                    width: "60px",
                    height: "60px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    padding: 2,
                    fontSize: theme.typography.h6.fontSize,
                  },
                })}
              >
                {vertical.icon}
                <span>{vertical.label}</span>
              </Typography>
            </Link>
          ))}
        </Box>
      </Box>

      <Box
        sx={(theme) => ({
          display: "flex",
          gap: 8,
          margin: "0 auto",
          [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            gap: 2,
          },
        })}
      >
        <OptionsLinkSection title="Breeds" options={BREED_OPTIONS} />
        <OptionsLinkSection title="Disciplines" options={DISCIPLINE_OPTIONS} />
      </Box>
    </BoxWithGutters>
  );
}
